// extracted by mini-css-extract-plugin
module.exports = {"container":"ExistingJobRef_container__1DOdS","coverImg":"ExistingJobRef_coverImg__X3CO8","title":"ExistingJobRef_title__39TNq","content":"ExistingJobRef_content__3Pr6R"};